import r from "./index415.js";
import { createElementBlock as o, openBlock as t, mergeProps as a, renderSlot as n } from "vue";
/* empty css         */
import s from "./index231.js";
const p = ["href", "target", "rel", "data-component"];
function c(e, m, d, f, i, l) {
  return t(), o("a", a({
    class: "ms-clickArea",
    href: e.href,
    target: e.target,
    rel: e.rel,
    "data-component": e.$options.name
  }, e.tracking), [
    n(e.$slots, "default", {}, void 0, !0)
  ], 16, p);
}
const h = /* @__PURE__ */ s(r, [["render", c], ["__scopeId", "data-v-0a2bb1bc"]]);
export {
  h as default
};
